var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9C0.5 4.28864 4.28864 0.5 9 0.5C13.7114 0.5 17.5 4.28864 17.5 9C17.5 13.7114 13.7114 17.5 9 17.5C4.28864 17.5 0.5 13.7114 0.5 9Z",
    stroke: "#FFCD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9021 8.235C12.9021 7.9929 12.8059 7.76071 12.6347 7.58951C12.4635 7.41832 12.2314 7.32214 11.9893 7.32214H6.05568C5.81357 7.32214 5.58139 7.41832 5.41019 7.58951C5.239 7.76071 5.14282 7.9929 5.14282 8.235V12.7993C5.14282 13.0414 5.239 13.2736 5.41019 13.4448C5.58139 13.616 5.81357 13.7121 6.05568 13.7121H11.9893C12.2314 13.7121 12.4635 13.616 12.6347 13.4448C12.8059 13.2736 12.9021 13.0414 12.9021 12.7993V8.235Z",
    stroke: "#FFCD00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51208 5.72464C6.51208 5.05885 6.77657 4.42033 7.24735 3.94955C7.71813 3.47876 8.35665 3.21428 9.02244 3.21428C9.68823 3.21428 10.3267 3.47876 10.7975 3.94955C11.2683 4.42033 11.5328 5.05885 11.5328 5.72464V7.32214H6.51208V5.72464Z",
    stroke: "#FFCD00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02244 11.0877C9.33754 11.0877 9.59298 10.8322 9.59298 10.5171C9.59298 10.202 9.33754 9.94659 9.02244 9.94659C8.70734 9.94659 8.4519 10.202 8.4519 10.5171C8.4519 10.8322 8.70734 11.0877 9.02244 11.0877Z",
    stroke: "#FFCD00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1e2e6e4880c603f1bfce9bcde45e61bd.svg";
export { ForwardRef as ReactComponent };